import { RangeObservable } from './RangeObservable';
export var range = RangeObservable.create;
//# sourceMappingURL=range.js.map